module.exports = __webpack_public_path__ + "static/media/vintage10.33869d5f.png";